module.exports = __webpack_public_path__ + "static/media/ren_active47199a9c976aa57b650b0cbcdf43bc61.webp";